import { VisibilityOff } from '@mui/icons-material';
import { ReactElement, useState } from 'react';
import { Button, Confirm, useListContext, useNotify, useRefresh, useUpdateMany } from 'react-admin';

export default function BulkHideButton(): ReactElement {
  const { selectedIds, onUnselectItems } = useListContext();
  const [updateMany, updateStatus] = useUpdateMany();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const isDisabled = selectedIds.length === 0 || updateStatus.isPending || updateStatus.isLoading;

  const handleConfirm = () => {
    setIsConfirmOpen(false);

    updateMany(
      'mapping_rules',
      {
        ids: selectedIds,
        data: {
          attributes: {
            is_hidden: true,
          },
        },
      },
      {
        onSuccess: () => {
          notify('Mapping Rules updated', { type: 'success' });
          onUnselectItems();
          refresh();
        },
        onError: (error) => {
          notify((error as Error).message, { type: 'error' });
        },
      },
    );
  };

  return (
    <>
      <Button label="Hide Rules" onClick={() => setIsConfirmOpen(true)} disabled={isDisabled}>
        <VisibilityOff />
      </Button>
      <Confirm
        isOpen={isConfirmOpen}
        title={`Hide ${selectedIds.length} mapping rule${selectedIds.length === 1 ? '' : 's'}?`}
        content={`This will make ${selectedIds.length === 1 ? 'this rule' : 'these rules'} invisible, but will not prevent ${selectedIds.length === 1 ? 'it' : 'them'} from running`}
        onConfirm={handleConfirm}
        onClose={() => setIsConfirmOpen(false)}
      />
    </>
  );
}
